import { createUseStyles } from 'react-jss';

import colors from "../../../utils/colors";






var styles = {
  attributeNameCell: {
    width: '25rem',
    fontSize: '1.4rem',
    lineHeight: '2rem',
    padding: '1.5rem 1rem 1.5rem 2.4rem',
    border: "0.1rem solid ".concat(colors.neutral[300]),
    borderRight: "0.1rem solid ".concat(colors.neutral[600]),
    borderLeft: 'none',
    '&:last-child': {
      borderRight: 'none'
    }
  },
  comparisonTableBody: {
    overflowY: 'initial'
  },
  marketingTagsCell: {
    padding: '1.5rem 1rem 1.5rem 2.4rem'
  },
  lastProductCell: {
    border: "0.1rem solid ".concat(colors.neutral[300]),
    borderRight: "0.1rem solid ".concat(colors.neutral[600]),
    borderLeft: 'none',
    '&:last-child': {
      borderRight: 'none'
    }
  },
  categoryRow: function categoryRow(_ref) {var columnsAmount = _ref.columnsAmount,showWideColumns = _ref.showWideColumns;return {
      backgroundColor: colors.neutral[800],
      // 25 rem is 1st column with attribute name,
      // width of column with attribute value - 34rem/40rem
      width: showWideColumns ? "".concat(40 * columnsAmount + 25, "rem") : "".concat(34 * columnsAmount + 25, "rem")
    };},
  categoryCell: {
    color: colors.neutral.white,
    fontSize: '1.6rem',
    padding: '1.5rem 1rem 1.5rem 2.4rem'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map